import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { FullDate } from '../../../../components/Date/FullDate'
import { CustomBtn } from '../../../../components/button/button'
import { Input } from '../../../../components/input/input'
import { Main } from '../../../../constant'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import CustomTable from '../../../../components/table/SimpleTable'
import { ShowLoader } from '../../../../redux/actions/loader'
import CustomTableAllTransport from './components/allTransportTable'

function DefaulterTransportStudents() { 
  const url = useSelector((state) => state.Api);
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const [allStudents, setAllStudents] = useState('');
  const dispatch = useDispatch();
  const apiCalled  = useRef(false)

  function receivedFees() {
    // e.preventDefault();
    if (apiCalled.current) return;  // Exit if API was already called
        apiCalled.current = true; 

    try {
      dispatch(ShowLoader('1')) 
      axios.get(url.allDefaulters, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            dispatch(ShowLoader('0')) 
            //console.log(res.data.result);
            setAllStudents(res.data.result)
          }
        })
        .catch((err) => {
          dispatch(ShowLoader('0')) 
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      dispatch(ShowLoader('0')) 
      //console.error(err);
    }
  }
       
  useEffect(() => {
    receivedFees()
  }, [])
 
 
    return (
        <>
  <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', width:'117%' }}>
  {
                        allStudents && allStudents.length != 0 && allStudents != '' && allStudents != undefined  ?
                        <CustomTableAllTransport data={allStudents} />            
                        :
                        null
                    }
          </Box>
        </>
    )
}

export default DefaulterTransportStudents
